export default "<button class=\"btn btn-default\" ng-click=\"$ctrl.click()\">{{$ctrl.label}}</button>";